var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M14.814 14.154V6.77H5.333v6.153c0 .448-.116.868-.318 1.231h9.8zM16 15.384H2.963c-1.307 0-2.37-1.103-2.37-2.46V0h4.986l2.37 2.462h5.68v2.461h-1.185v-1.23H7.458L5.088 1.23h-3.31v11.692c0 .679.532 1.231 1.185 1.231.654 0 1.185-.552 1.185-1.23V5.538H16v9.846z"
  })));
}
export default SvgIconFolder;